import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BASE_URL, comment, reply } from "../../api/endpoints";
import { dateFormatter } from "../../utils/Utils";
import parse from "html-react-parser";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { setBlogcomment, setLogin, setReply } from "../../redux/slice/Slice";
import ErrorMessage from "../../common/errormsg/ErrorMessage";
import { FaCalendarAlt } from "react-icons/fa";
import CompanyLogo from "../../common/CompanyLogo";
function BlogDeatils() {
  const locations = useLocation();
  const dispatch = useDispatch();
  const blogcomment = useSelector((state) => state.auth.blogcomment);
  const replydata = useSelector((state) => state.auth.reply);
  const data = locations.state?.item;
  const api = Api_Instance.useApi();
  const [commentdata, setComment] = useState([]);
  const [activeComment, setActiveComment] = useState(null);
  const [replytext, setreplytext] = useState(replydata);
  const [replyid, setreplyId] = useState([]);
  const [errors, setErrors] = useState({});
  const initialValue = {
    text: "",
    name: "",
    email: "",
    image: "",
    blog: data?.id,
  };
  const [formvalue, setFormvalue] = useState({
    text: "",
    name: "",
    email: "",
    image: "",
    blog: data?.id,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormvalue((prev) => ({
      ...prev,
      [name]: value,
    }));
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  const Postcomment = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      try {
        const res = await api("POST", comment.POST_COMMENT, formvalue);
        dispatch(setBlogcomment(res?.data?.data));
        if (res?.data?.status == true) {
          getcomment();
          setFormvalue(initialValue);
          toast.success(res?.data?.message);
        }
      } catch (error) {
        if (
          error?.response?.data?.detail ===
          "Authentication credentials were not provided."
        ) {
          toast.error("please login you are not authorized");
        } else if (error?.response?.data?.code === "token_not_valid") {
          toast.error("Session expired please login again");
        } else {
          toast.error(error.message || "invalid data");
        }
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formvalue.name) {
      newErrors.name = "Name is required";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formvalue.email || !emailRegex.test(formvalue.email)) {
      newErrors.email = "Email is required";
    }

    if (!formvalue.text) {
      newErrors.text = "Message is required";
    }
    return newErrors;
  };

  const getcomment = async () => {
    try {
      const res = await api(
        "GET",
        `${comment.GET_COMMENT}?blog_id=${data?.id}`
      );
      setComment(res?.data?.data);
    } catch (error) { }
  };

  const Postreply = async (e, id) => {
    setreplyId([...replyid, id]);
    e.preventDefault();
    try {
      const res = await api("POST", reply.POST_REPLY, {
        text: replytext,
        comment: id,
      });
      if (res?.data?.status == true) {
        toast.success(res?.data?.message);
        dispatch(setReply(res?.data?.data));

        setActiveComment(null);
      }
      setFormvalue(res?.data?.data);
    } catch (error) { }
  };
  //getreply
  const getreply = async () => {
    try {
      const res = await api("GET", reply.GET_REPLY);
      if (res?.data?.status == true) {
        dispatch(setReply(res?.data?.data));
      }
    } catch (error) { }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };
  useEffect(() => {
    getreply();
    getcomment();
  }, [activeComment]);
  const handleReplyClick = (commentId) => {
    setActiveComment(activeComment === commentId ? null : commentId);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [commentsPerPage] = useState(5);

  const paginatedComments = commentdata.slice(0, currentPage * commentsPerPage);

  const loadMoreComments = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };
  return (
    <div>
      {/* <div className="bg-subheader_background w-full h-32 flex flex-col items-center justify-center">
        <CompanyLogo title={"Blogs"} subtitle={"Blogs"} />
      </div> */}

      <div className="flex flex-col md:flex-row justify-between w-full mx-auto mt-10 gap-5 relative max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4">
        <div className="bg-card_bg_color w-full md:w-3/4 rounded-md overflow-y-auto h-96 md:h-[600px]">
          <div className="p-4 bg-[#f2f2f2] sticky top-0">
            <p className="text-primaryColor text-[20px] font-semibold"> {data?.heading}</p>
            <p className="text-lg font-semibold text-text_color mt-2">
              {/* {parse(data?.description)} */}
            </p>
            <hr className="mt-2  w-full" />
          </div>
          <div className="flex justify-center p-3">
            <img
              className="w-full h-72 "
              src={`${data?.image}`}
              alt="Blog Post"
            />
          </div>
          <div className="w-full p-4 mt-2">
            <div className="flex gap-4 mt-3">
              <div className="flex gap-2">
                <span>
                  <img
                    className="w-5"
                    src="../../../../img/adminicon.png"
                    alt="Admin Icon"
                  />
                </span>
                <p className="text-sm">Admin</p>
              </div>
              <div className="flex gap-2">
                <span>
                  <img
                    className="w-5"
                    src="../../../../img/dateicon.png"
                    alt="Date Icon"
                  />
                </span>
                <p className="text-sm"> {dateFormatter(data?.created_time)}</p>
              </div>
            </div>
            <div className="mt-2 p-2">
              <h3 className="text-2xl font-semibold">
                Open communication and shared values
              </h3>
              <p className="text-subtext_color mt-1">
                {parse(data?.description || "")}
              </p>
            </div>
            {/* <div className="mt-2 p-2">
              <h3 className="text-2xl font-semibold">
                Open communication and shared values
              </h3>
              <p className="text-subtext_color mt-1">
                Begin your search by researching branding agencies that have a
                strong track record in delivering successful rebranding
                projects. Look for agencies that have experience in your
                industry and a portfolio that resonates with your brand’s
                aesthetic and values.
              </p>
              <p className="text-subtext_color mt-1">
                Begin your search by researching branding agencies that have a
                strong track record in delivering successful rebranding
                projects. Look for agencies that have experience in your
                industry and a portfolio that resonates with your brand’s
                aesthetic and values.
              </p>
            </div>
            <div className="mt-2 p-2">
              <h3 className="text-2xl font-semibold">
                Open communication and shared values
              </h3>
              <p className="text-subtext_color mt-1">
                Begin your search by researching branding agencies that have a
                strong track record in delivering successful rebranding
                projects. Look for agencies that have experience in your
                industry and a portfolio that resonates with your brand’s
                aesthetic and values.
              </p>
              <p className="text-subtext_color mt-1">
                Begin your search by researching branding agencies that have a
                strong track record in delivering successful rebranding
                projects. Look for agencies that have experience in your
                industry and a portfolio that resonates with your brand’s
                aesthetic and values.
              </p>
            </div> */}
          </div>
        </div>

        {/* <div className="flex flex-col space-y-4 sticky right-12 top-0">
          <div className="w-full h-atuo  bg-card_bg_color p-3 ">
            <div className="w-full">
              <h3 className="text-[#F26C41] font-semibold text-xl">
                Recent Blog
              </h3>
              <hr className="mt-2 w-full" />
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                Best Pre School Franchise In India Bachpan
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 16-May-2024
              </p>
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                How To Start Cloud Kitchen Franchise
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 6-May-2024
              </p>
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                Low Cost & High Return Business Opportunity
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 5-APRIL-2024
              </p>
            </div>
          </div>
          <div className="w-full h-auto  bg-card_bg_color p-3">
            <div className="w-full">
              <h3 className="text-[#F26C41] font-semibold text-xl">Trending</h3>
              <hr className="mt-2 w-full" />
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                Latest Franchise Opportunities In India
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 16-May-2024
              </p>
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                Which Food Franchises are the Most Profitable in India
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 6-May-2024
              </p>
            </div>
            <div className="w-full p-2">
              <h3 className="text-text_color">
                The Opportunities And Challenges Of The Franchise Business
              </h3>
              <p className="text-subtext_color text-sm mt-1">
                by Admin, 5-APRIL-2024
              </p>
            </div>
          </div>
        </div> */}
      </div>
      <hr className="text-3xl font-semibold mt-5  w-full md:w-1/2 md:ml-64" />
      <div className="w-full md:w-1/2 md:ml-64">
        <h2 className="font-semibold p-2 mt-3">Comments</h2>
        {/* <div className="flex flex-col md:flex-row justify-between w-full mt-4">
          <div className="flex flex-col md:flex-row items-start md:items-center w-full md:w-3/4">
            <img
              className="w-12 md:mr-4"
              src="../../../../img/Ellipse 12 (2).png"
              alt="Profile"
            />
            <div className="flex flex-col">
              <h3>Frederic Hill</h3>
              <p className="mt-2 md:mt-0 text-subtext_color">
                Begin your search by researching branding agencies that have a
                strong track record in delivering successful rebranding
                projects.
              </p>
            </div>
          </div>
          <p className="mt-2 md:mt-0 text-sm md:ml-4 md:w-1/4 text-right md:text-left text-[#A19FB5]">
            September 13, 2023 / 9:20 am
          </p>
        </div> */}
        {/* <hr className="text-3xl font-semibold mt-2  w-full " /> */}
        <div className="scroll h-64 overflow-y-auto">
          {paginatedComments?.map((item) =>item?.status && (
            <>
              <div className="flex flex-col md:flex-row justify-between w-full mt-3">
                <div className="flex flex-col md:flex-row items-start md:items-center w-full md:w-3/4">
                  <img
                    className="w-12 md:mr-4 rounded-full"
                    src={`${item?.image}`}
                    alt="Profile"
                  />
                  <div className="flex flex-col">
                    <h3>{item?.name}</h3>

                    <p className="mt-2 md:mt-0 text-subtext_color">
                      {item?.text}
                    </p>
                    <span
                      className="mt-1 cursor-pointer"
                      style={{ color: "#0099c7" }}
                      onClick={() => handleReplyClick(item.id)}
                    >
                      Reply
                    </span>

                    {/* Conditional rendering of the reply modal */}
                    {activeComment === item.id && (
                      <div className="mt-2 p-2 bg-gray-100 rounded">
                        <textarea
                          className="w-full p-2 border border-gray-300 rounded"
                          placeholder="Write your reply..."
                          // value={replytext}
                          onChange={(e) => setreplytext(e.target.value)}
                        />
                        <div className="mt-2 flex justify-end">
                          <button
                            className="mr-2 px-4 py-2 bg-subtext_color rounded text-white"
                            onClick={() => setActiveComment(null)}
                          >
                            Cancel
                          </button>
                          <button
                            className="px-4 py-2 bg-primaryColor text-white rounded"
                            onClick={(e) => {
                              Postreply(e, item.id);
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <p className="mt-2 md:mt-0 text-sm md:ml-4 md:w-1/4 text-right md:text-left text-[#A19FB5]">
                  September 13, 2023 / 9:20 am.
                </p>
              </div>
              {item?.replies.length > 0 &&
                item?.replies?.map((data) => (
                  <>
                    <div className="flex flex-col md:flex-row justify-between w-full p-3">
                      <div className="flex flex-col md:flex-row items-start md:items-center w-full md:w-1/2 mx-auto">
                        <img
                          className="w-12 md:mr-4"
                          src="../../../../img/Ellipse 12 (2).png"
                          alt="Profile"
                        />
                        <div className="flex flex-col">
                          <h3>Frederic Hill</h3>
                          <p className="mt-2 md:mt-0 text-subtext_color">
                            {data?.text}
                          </p>
                        </div>
                      </div>
                      <p className="mt-2 md:mt-0 text-sm md:ml-4 md:w-1/4 mx-auto text-right md:text-left text-[#A19FB5]">
                        September 13, 2023 / 9:20 am
                      </p>
                    </div>
                  </>
                ))}
            </>
          ))}
          {/* Load More Button */}
          {currentPage * commentsPerPage < commentdata.length && (
            <div className="text-center my-4">
              <button
                className="px-4 py-2 bg-primaryColor text-white rounded"
                onClick={loadMoreComments}
              >
                Load More
              </button>
            </div>
          )}
        </div>
        <hr className="text-3xl font-semibold mt-1  w-full " />
        <div className="flex flex-col mt-4">
          <h2 className="font-semibold">Leave a Reply</h2>
          <p className="mt-1 text-subtext_color">
            Your email address will not be published. Required fields are marked
          </p>
          <form>
            <div className="col-span-2 mt-4">
              <label
                for="PropertyDetails"
                className="py-2 text-gray-500 pointer-events-none"
              >
                Comment<span className="text-star_color">*</span>
              </label>
              <textarea
                className="block w-full px-2 h-20 py-1 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Comment"
                id="floatingTextarea2"
                name="text"
                value={formvalue.text}
                onChange={handleChange}
              ></textarea>
              {errors.text && <ErrorMessage error={errors.text} />}
            </div>

            <div className="flex flex-col md:flex-row gap-4 mt-4">
              <div className="flex-1">
                <label htmlFor="FirstName" className="mb-1 font-md block capitalize">
                  First Name <span className="text-star_color">*</span>
                </label>
                <input
                  type="text"
                  id="FirstName"
                  name="name"
                  value={formvalue.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter First Name"
                  className="p-2 border border-gray-300 rounded w-full"
                />
                {errors.name && <ErrorMessage error={errors.name} />}
              </div>
              <div className="flex-1">
                <label htmlFor="email" className="mb-1 font-md block capitalize">
                  Email <span className="text-star_color">*</span>
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={formvalue.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Email"
                  className="p-2 border border-gray-300 rounded w-full"
                />
                {errors.email && <ErrorMessage error={errors.email} />}
              </div>
              <div className="flex-1">
                <label htmlFor="Website" className="mb-1 font-md block capitalize">
                  Website
                </label>
                <input
                  type="text"
                  id="Website"
                  name="image"
                  value={formvalue.image}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Website"
                  className="p-2 border border-gray-300 rounded w-full"
                />
              </div>
            </div>

            <div className="mt-4">
              <div>
                <input
                  type="checkbox"
                  id="agreementNo"
                  name="standardBrandAgreement"
                  value="no"
                />
                <label htmlFor="agreementNo" className="ml-2 font-sm text-sm">
                  Save my name, email, and website in this browser for the next
                  time I comment.
                </label>
              </div>
            </div>

            <div className="flex justify-start items-center mt-4">
              <button
                type="submit"
                className="bg-primaryColor text-white p-2 rounded w-32 [transition:all_.15s_ease-in-out]"
                onClick={(e) => Postcomment(e)}
              >
                Post Comment
              </button>
            </div>
          </form>
        </div>
        <div className="mt-16">
          <div>
            <h1 className="text-3xl font-md">
              You May{" "}
              <span className="text-primaryColor text-3xl">Also Like</span>
            </h1>
          </div>
          <hr className="text-3xl font-semibold mt-3  w-full " />
          <div className="flex flex-col md:flex-row space-y-3 md:space-y-0  justify-between mt-4">
            <div className="relative  ml-10 md:ml-0 ">
              <img className="w-56" src="../../../../img/Rectangle 98.png" />
              <div className="absolute top-24 left-2">
                <div className="flex gap-2">
                  <span>
                    <FaCalendarAlt />
                  </span>
                  <span className="text-white text-sm"> 24 Mar 2024</span>
                </div>
                <p className="text-sm text-white mt-1 ml-1">
                  India's Well Known Clothing Retail Brand
                </p>
              </div>
            </div>
            <div className="relative  ml-10 md:ml-0  ">
              <img className="w-56 " src="../../../../img/Rectangle 98.png" />
              <div className="absolute top-24 left-2">
                <div className="flex gap-2">
                  <span>
                    <FaCalendarAlt />
                  </span>
                  <span className="text-white text-sm"> 24 Mar 2024</span>
                </div>
                <p className="text-sm text-white mt-1 ml-1">
                  India's Well Known Clothing Retail Brand
                </p>
              </div>
            </div>
            <div className="relative  ml-10 md:ml-0 ">
              <img className="w-56" src="../../../../img/Rectangle 98.png" />
              <div className="absolute top-24 left-2">
                <div className="flex gap-2">
                  <span>
                    <FaCalendarAlt />
                  </span>
                  <span className="text-white text-sm"> 24 Mar 2024</span>
                </div>
                <p className="text-sm text-white mt-1 ml-1">
                  India's Well Known Clothing Retail Brand
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogDeatils;
